module.exports = __webpack_public_path__ + "394586e4f6c7258ae21f0b7f7ea0e2ef.svg";